import React, { useEffect, useState } from 'react'
import Chart from 'react-apexcharts'

import {
  Box,
  Button,
  CircularProgress,
  CircularProgressLabel,
  Flex,
  Grid,
  Icon,
  Progress,
  SimpleGrid,
  Spacer,
  Stack,
  Stat,
  StatHelpText,
  StatLabel,
  StatNumber,
  Table,
  Tbody,
  Text,
  Th,
  Thead,
  Tr, Card, CardBody, CardHeader, CardFooter, Select, HStack, Td, Skeleton,
  Image,
  useBreakpointValue,
  Heading,
  Link,
  IconButton
} from '@chakra-ui/react';
import { AiFillCheckCircle } from 'react-icons/ai';
import { BiHappy, BiSolidCameraMovie, BiSolidDiscount } from 'react-icons/bi';
import { BsArrowRight, BsPersonVcardFill } from 'react-icons/bs';
import { IoCheckmarkDoneCircleSharp, IoDocument, IoEllipsisHorizontal } from 'react-icons/io5';
import { FaUserGroup } from "react-icons/fa6";
import { useTranslation } from 'react-i18next';
import { FaUserCheck, FaUserTie } from 'react-icons/fa';
import IconBox from '../../components/Icons/IconBox';
import { MdLocalMovies, MdOutlineCurrencyExchange } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import axiosClient from '../../axios-client';
import imgDash from '../../assets/images/image.jpg'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./SwiperStyles.css";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import { useStateContext } from '../../context/ContextProvider';
import { ImStatsBars } from 'react-icons/im';

ChartJS.register(ArcElement, Tooltip, Legend);

function Dashboard() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [clientsCount, setClientsCount] = useState(0)
  const [adminsCount, setAdminsCount] = useState(0)
  const [moviesCount, setMoviesCount] = useState(0)
  const [seriesCount, setSeriesCount] = useState(0)
  const [categoriesCount, setCategoriesCount] = useState(0)
  const [subscribedClientsCount, setSubscribedClientsCount] = useState(0)
  const [top10Contents, setTop10Contents] = useState([])
  const width = useBreakpointValue({ base: "250px", sm: "300px", lg: '350px', xl: '400px' });
  const { user } = useStateContext()
  const fetchTop10Contents = () => {
    axiosClient.get('top-10-contents/')
      .then((response) => {
        setTop10Contents(response.data.top_contents)
      })
      .catch((error) => {
        // console.error(error);
      });
  }
  const fetchClients = () => {
    axiosClient.get('count_clients/')
      .then((response) => {
        setClientsCount(response.data.count)
      })
      .catch((error) => {
        // console.error(error);
      });
  }
  const fetchSubscribedClients = () => {
    axiosClient.get('count_subscribed_clients/')
      .then((response) => {
        setSubscribedClientsCount(response.data.count)
      })
      .catch((error) => {
        // console.error(error);
      });
  }
  const fetchAdmins = () => {
    axiosClient.get('count_admins/')
      .then((response) => {
        setAdminsCount(response.data.count)
      })
      .catch((error) => {
        // console.error(error);
      });
  }
  const fetchCategories = () => {
    axiosClient.get('count_categories/')
      .then((response) => {
        setCategoriesCount(response.data.count)
      })
      .catch((error) => {
        // console.error(error);
      });
  }
  const fetchMovies = () => {
    axiosClient.get('count_movies/')
      .then((response) => {
        setMoviesCount(response.data.count)
      })
      .catch((error) => {
        // console.error(error);
      });
  }
  const fetchSeries = () => {
    axiosClient.get('count_series/')
      .then((response) => {
        setSeriesCount(response.data.count)
      })
      .catch((error) => {
        // console.error(error);
      });
  }
  useEffect(() => {
    fetchClients()
    fetchSubscribedClients()
    fetchCategories()
    fetchAdmins()
    fetchMovies()
    fetchSeries()
    fetchTop10Contents()

  }, []);
  const customSettings = {
    breakpoints: {
      0: { slidesPerView: 1, slidesPerGroup: 1 }, // xs: 1 slide per view
      400: { slidesPerView: 2, slidesPerGroup: 2 },

      640: { slidesPerView: 2, slidesPerGroup: 2 }, // sm: 2 slides per view
      768: { slidesPerView: 2, slidesPerGroup: 2 }, // md: 3 slides per view
      1024: { slidesPerView: 3, slidesPerGroup: 3 }, // lg and xl: 4 slides per view
      1280: { slidesPerView: 4, slidesPerGroup: 4 }, // Above xl: 5 slides per view
      1536: { slidesPerView: 4, slidesPerGroup: 4 },
      1690: { slidesPerView: 5.5, slidesPerGroup: 5 },
      1800: { slidesPerView: 6.1, slidesPerGroup: 5 },

    },
  };
  const unsubscribedClientsCount = clientsCount - subscribedClientsCount;

  const [chartData, setChartData] = useState({
    series: [{ name: "Nombre d'utilisations", data: [] }],
    options: {
      chart: {
        type: "bar",
        height: 400,
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "45%",
          endingShape: "rounded",
          distributed: true,
        },
      },
      dataLabels: {
        enabled: false,
      },
      xaxis: {
        categories: [],
      },
      yaxis: {
        title: {
          text: "Nombre d'utilisations",
        },
      },
      colors: ["#F4D03F", "#fa8d51", "#6ad7d9", "#431F54", "#FF33A6"], // Set different colors for each bar
    },
  });

  const data = {
    series: [subscribedClientsCount, unsubscribedClientsCount], // Example data: 80 total clients, 20 subscribed clients
    options: {
      chart: {
        type: 'donut',

      },
      labels: ['Clients abonnés', 'Clients non abonnés'],
      legend: {
        position: 'bottom',
      },
      plotOptions: {
        pie: {
          donut: {
            labels: {
              show: true,
              total: {
                show: true,
                label: 'Total',
                formatter: () => clientsCount, // Example: Total clients
              },
            },
          },
        },
      },
      dataLabels: {
        enabled: true,
        formatter: (val) => `${val.toFixed(1)}%`, // Display percentage
      },
      tooltip: {
        enabled: true,
        y: {
          formatter: (val) => `${val}`, // Display raw value
        },
      },
      colors: ['#fa8d51', '#6ad7d9'],
    },
  };
  useEffect(() => {
    axiosClient.get("/top-influencers/")
      .then(response => {
        setChartData(prevData => ({
          ...prevData,
          series: [{ name: "Nombre d'utilisations", data: response.data.counts }],
          options: { ...prevData.options, xaxis: { categories: response.data.names } },
        }));
      })
      .catch(error => console.error("Error fetching influencer data:", error));
  }, []);
  return (
    <Flex flexDirection='column' >
      <Flex pt='12px' mb={8} justify={"space-between"} align={"center"}>
        <Box >
          <Text fontFamily='Plus Jakarta Display' as="cite" fontSize={{ base: "18px", md: "20px", lg: "25px" }} color="gray"><span onClick={() => navigate('/')} style={{ cursor: 'pointer' }} onMouseEnter={e => e.target.style.textDecoration = "underline"} onMouseLeave={e => e.target.style.textDecoration = "none"} > {t("Accueil")}</span>  / <span >{t("Tableau de bord")}</span></Text>
        </Box>
        {user.role === "SUPERADMIN" &&
          <Button onClick={() => navigate('/stats')} color={"white"} bgGradient='linear(to-r, #eb6921, #fa8d51)' _hover={{ bgGradient: 'linear(to-r, #eb6921,#eb6921)' }} variant='solid'>
            {t("Statistiques d'abonnement")}
          </Button>
        }


      </Flex>
      <SimpleGrid columns={{ sm: 1, md: 2, lg: 3, xl: 5 }} spacing='15px'>
        {/* MiniStatistics Card */}
        <Card bg='linear-gradient(71deg, rgba(75,47,97,1) 0%, rgba(38,23,48,1) 53%, rgba(28,17,36,1) 100%)'>
          <CardBody p={4}>
            <Flex flexDirection='row' align='center' justify='center' w='100%'>
              <Stat me='auto'>
                <StatLabel fontSize='sm' color='gray.400' fontWeight='bold' pb='2px'>
                  {t("Clients")}
                </StatLabel>
                <Flex>
                  <StatNumber fontSize='lg' color='#fff'>
                    {clientsCount}
                  </StatNumber>
                </Flex>
              </Stat>
              <IconBox h={'40px'} w={'40px'} bg='brand.200'>
                <FaUserGroup size={"25px"} color='#fff' />
              </IconBox>
            </Flex>
          </CardBody>
        </Card>

        {/* MiniStatistics Card */}
        <Card bg='linear-gradient(71deg, rgba(75,47,97,1) 0%, rgba(38,23,48,1) 53%, rgba(28,17,36,1) 100%)'>
          <CardBody p={4}>
            <Flex flexDirection='row' align='center' justify='center' w='100%'>
              <Stat>
                <StatLabel fontSize='sm' color='gray.400' fontWeight='bold' pb='2px'>
                  {t("Administrateurs")}
                </StatLabel>
                <Flex>
                  <StatNumber fontSize='lg' color='#fff'>
                    {adminsCount}
                  </StatNumber>
                </Flex>
              </Stat>
              <IconBox h={'40px'} w={'40px'} bg='brand.200'>
                <FaUserTie size={"25px"} color='#fff' />
              </IconBox>
            </Flex>
          </CardBody>
        </Card>
        {/* MiniStatistics Card */}
        <Card bg='linear-gradient(71deg, rgba(75,47,97,1) 0%, rgba(38,23,48,1) 53%, rgba(28,17,36,1) 100%)' minH='83px'>
          <CardBody p={4}>
            <Flex flexDirection='row' align='center' justify='center' w='100%'>
              <Stat me='auto'>
                <StatLabel fontSize='sm' color='gray.400' fontWeight='bold' pb='2px'>
                  {t("Catégories")}
                </StatLabel>
                <Flex>
                  <StatNumber fontSize='lg' color='#fff'>
                    {categoriesCount}
                  </StatNumber>
                </Flex>
              </Stat>
              <IconBox h={'40px'} w={'40px'} bg='brand.200'>
                <FaUserCheck size={"25px"} color='#fff' />
              </IconBox>
            </Flex>
          </CardBody>
        </Card>
        {/* MiniStatistics Card */}
        <Card bg='linear-gradient(71deg, rgba(75,47,97,1) 0%, rgba(38,23,48,1) 53%, rgba(28,17,36,1) 100%)'>
          <CardBody p={4}>
            <Flex flexDirection='row' align='center' justify='center' w='100%'>
              <Stat me='auto'>
                <StatLabel fontSize='sm' color='gray.400' fontWeight='bold' pb='2px'>
                  {t("Films")}
                </StatLabel>
                <Flex>
                  <StatNumber fontSize='lg' color='#fff'>
                    {moviesCount}
                  </StatNumber>
                </Flex>
              </Stat>
              <IconBox h={'40px'} w={'40px'} bg='brand.200'>
                <MdLocalMovies size={"28px"} color='#fff' />
              </IconBox>
            </Flex>
          </CardBody>
        </Card>
        <Card bg='linear-gradient(71deg, rgba(75,47,97,1) 0%, rgba(38,23,48,1) 53%, rgba(28,17,36,1) 100%)'>
          <CardBody p={4}>
            <Flex flexDirection='row' align='center' justify='center' w='100%'>
              <Stat me='auto'>
                <StatLabel fontSize='sm' color='gray.400' fontWeight='bold' pb='2px'>
                  {t("Séries")}
                </StatLabel>
                <Flex>
                  <StatNumber fontSize='lg' color='#fff' fontWeight='bold'>
                    {seriesCount}
                  </StatNumber>
                </Flex>
              </Stat>
              <IconBox h={'40px'} w={'40px'} bg='brand.200'>
                <BiSolidCameraMovie size={"25px"} color='#fff' />
              </IconBox>
            </Flex>
          </CardBody>
        </Card>
      </SimpleGrid>

      <Flex py={6} w={"100%"} direction={"column"}>
        <Flex align={"center"} justifyContent={"space-between"}>
          <Text fontSize={'xl'} fontWeight={"semibold"} mb={-3}>Contenus les plus regardés</Text>
          <Link onClick={() => { navigate("/contents-stats") }} textStyle={"underline"} fontSize={'md'} fontWeight={"semibold"} mb={-3}>Voir tout</Link>
        </Flex>

        <Swiper
          {...customSettings}
          modules={[Navigation, Pagination]}
          spaceBetween={15}
          // slidesPerView={4}
          navigation
          pagination={false}
          style={{ width: "100%", height: "100%" }}
          className="SwiperStyle h-full"
        >
          {top10Contents.map((obj, index) => {
            return (
              <SwiperSlide key={index} className="bg-cover">
                <Box position="relative" height={{ base: "120px", sm: "120px", md: "150px" }}
                  w={"100%"} borderRadius="xl" overflow="hidden">
                  <Box position="absolute" top="5px" right="5px" zIndex="9" >
                    <IconButton
                      onClick={() =>
                        navigate(`/content-stats`, {
                          state: {
                            contentId: obj.id,
                            breadcrumbs: [
                              { path: '/contents-stats', label: 'Statistiques de visionnage' },
                            ]
                          },
                        })
                      }
                      size={"sm"}
                      borderRadius="xl"
                      // variant='outline'
                      colorScheme='whiteAlpha'
                      aria-label='Statistiques'
                      icon={<ImStatsBars color='orange' size={18} />}
                    />
                  </Box>
                  <Image
                    position={'absolute'}
                    loading="lazy"
                    borderRadius="xl"
                    height={"100%"}
                    minW={{ base: "100px", sm: "150px", xl: "200px" }}
                    w={"100%"}
                    objectFit="cover"
                    src={obj.image}
                    alt="Slide Image"
                  />
                  <Flex bg="blackAlpha.500" justify={"end"} direction={"column"} h={"100%"} position={"relative"} bottom={0} left={0} w={"100%"} className="content" >
                    <Text
                      ml="4"
                      color="white"
                      fontSize="md"
                      fontWeight="medium"
                      width="80%"
                      noOfLines={1} // For line clamping
                    >
                      {obj.title || ""}
                    </Text>
                    <Text
                      mb={5}
                      ml="4"
                      color="white"
                      fontSize="xl"
                      fontWeight="semibold"

                      width="92%"
                    >
                      regardé {obj.total_views} fois
                    </Text>
                  </Flex>
                </Box>
              </SwiperSlide>
            )
          })}

        </Swiper>
      </Flex>
      <Grid mb={5} templateColumns={{ sm: '1fr', lg: '1fr 1fr', xl: '2fr 4fr' }} gap='24px'>
        <Card >
          <CardHeader >
            <Flex direction='column'>
              <Text fontSize='lg' fontWeight='bold' pb='8px' >
                Statut d'abonnement des clients
              </Text>

            </Flex>

          </CardHeader>
          <CardBody p={0} pb={2}>
            <Flex w={"100%"} justify={"center"} align={"center"} direction='column' >
              <Chart options={data.options} series={data.series} type="donut" width={width} />
            </Flex>
          </CardBody>
        </Card>
        <Card >
          <CardHeader >
            <Flex justifyContent={"space-between"} align={"center"} >
              <Text fontSize='lg' fontWeight='bold' pb='8px' >
                Top 5 des influenceurs par utilisation de codes promo
              </Text>
              <Button
                colorScheme="cyan"
                variant={"ghost"}
                size="sm"

                onClick={() => navigate("/promo-usage")}
              >
                Voir détails
              </Button>

            </Flex>

          </CardHeader>
          <CardBody pb={2}>
            <div>
              <Chart options={chartData.options} series={chartData.series} type="bar" height={300} />
            </div>
          </CardBody>

        </Card>
      </Grid>
      <Card

        direction={{ base: 'column', md: 'row' }}
        overflow='hidden'
        variant='outline'
        maxH={"430px"}
      >


        <Stack >
          <CardBody h={"100%"} alignItems={"center"} justifyContent={"center"} flexDirection={"column"} color={"white"} background={"linear-gradient(135deg, #431F54, #151226, #17254A)"} display={'flex'}>
            <Heading style={{
              // textAlign: "center",
              color: "#FFFFFF",
              fontFamily: "'Inter', sans-serif",
              letterSpacing: "-0.05rem",
              width: "100%",
              lineHeight: "1.125",
              backgroundImage: "linear-gradient(45deg, rgba(255, 255, 255, 0.412) 0%, #FFFFFF 67%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }} size={{ base: "md", md: "lg", xl: "xl" }}>Une expérience de streaming unique</Heading>

            <Text fontSize={{ base: "md", xl: "lg" }} py='3' color={"#858592"}>
              Bien plus qu'une simple plateforme de streaming, Maya+ est une invitation à découvrir un monde de divertissement intelligent et éducatif, à explorer le cinéma indépendant sous un nouvel angle et à partager des moments précieux en famille.
            </Text>
          </CardBody>


        </Stack>
        <Image
          objectFit='cover'
          maxW={{ base: '100%', md: "200px", lg: '350px' }}
          src={imgDash}
          alt='dash'
        />
      </Card>

    </Flex>
  )
}

export default Dashboard